shadow$provide[532] = function(require,module,exports) {
var require$_DOT__SLASH_animator_DOT_js = require("./animator.js");
var require$_DOT__SLASH_api_DOT_js = require("./api.js");
var require$_DOT__SLASH_controller_DOT_js = require("./controller.js");
require.exportCopy(module, require$_DOT__SLASH_animator_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_api_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_controller_DOT_js);

};